import React from 'react';
import { Flex } from 'antd';
import { ReactComponent as EmptyIcon } from '@Icons/additional/no-data.svg';
import styles from './ContactNoData.module.css';

interface ContactNoDataProps {
  isSearchApplied?: boolean;
  isFiltersApplied?: boolean;
}

const ContactNoData: React.FC<ContactNoDataProps> = ({
  isSearchApplied = false,
  isFiltersApplied = false,
}) => {
  const getMessage = (): string => {
    if (isSearchApplied && isFiltersApplied) {
      return "Search and filter can't find any contacts matching your request";
    }
    if (isSearchApplied) {
      return "Search can't find any contacts matching your request";
    }
    if (isFiltersApplied) {
      return "Filter can't find any contacts matching your request";
    }
    return 'No contacts found';
  };

  return (
    <Flex vertical className={styles.wrapper}>
      <EmptyIcon />
      <Flex vertical className={styles.textWrapper}>
        <span className={styles.title}>No Data</span>
        <span className={styles.description}>{getMessage()}</span>
      </Flex>
    </Flex>
  );
};

export default ContactNoData;
